import "../css/main.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NoResults from "../NoResults";
import Header from "../components/Header";
import useSearch from "./useSearch";
import MainFrame from "../components/MainFrame";
import GenericModal from "../components/GenericModal";
import AddressesList from "./components/AddressesList";

export default function Search({
  width,
  reloadMap,
  addresses,
  openMap,
  iconColor,
}) {
  const {
    list,
    open,
    setOpen,
    mainTxt,
    setMainTxt,
    msgType,
    closeMsg,
    setSelectedPoint,
  } = useSearch({
    addresses,
    openMap,
  });

  return (
    <MainFrame width={width}>
      <Header
        MainIcon={LocationOnIcon}
        color={iconColor}
        input={true}
        value={mainTxt}
        clear={() => setMainTxt("")}
        onChange={(e) => {
          setMainTxt(e.target.value);
        }}
        refresh={() => {
          setOpen("loading");
          reloadMap();
        }}
      />
      <div
        style={{
          position: "relative",
          flex: 1,
          overflow: "auto",
          backgroundColor: "white",
          paddingBottom: 20,
        }}
      >
        {list.length === 0 && mainTxt !== "" ? (
          <NoResults />
        ) : (
          <AddressesList
            list={list}
            setSelectedPoint={setSelectedPoint}
            setOpen={setOpen}
          />
        )}
      </div>
      <GenericModal open={open} data={msgType[open]} close={closeMsg} />
    </MainFrame>
  );
}
